// @flow
import * as React from 'react';
import compose from 'recompose/compose';
import { useTranslation } from 'react-i18next';

import LinkButton from 'app/components/Tariff/LinkButton';
import RadioButton from 'app/common/ui/RadioButton';
import Confirmation from 'app/components/Tariff/Confirmation';
import confirmation from 'app/components/Tariff/Confirmation/confirmationState';
import PriceDiscounted, { priceTypes } from 'app/components/Tariff/PriceDiscounted';

import type { MonthDailyPeriod } from '../Tariff';
import enhancePeriods from './enhancePeriods';
import withSubmitPeriod from './withSubmitPeriod';
import styles from './Periods.scss';


const enhance = compose(
  enhancePeriods,
  withSubmitPeriod,
  confirmation
);

type Props = {
  subId?: number,
  isOpen: boolean,
  periods: Array<MonthDailyPeriod>,
  handleToggle: (e: SyntheticEvent<HTMLElement>) => void,
  externalToggle?: (e: SyntheticEvent<HTMLElement>) => void,
  handleCheck: (e: SyntheticEvent<HTMLElement>) => void,
  handleSubmit: (e: SyntheticEvent<HTMLElement>) => void,
  beginConfirmation: (e: SyntheticEvent<HTMLElement>) => void,
  stopConfirmation: (void) => void,
  submitting: boolean,
  months: ?number,
  comment: string,
  confirmationState: string,
  locked: boolean,
  header?: string,
  studentId: number,
  tariffId?: number,
  tariffBundleId?: number,
  isSms?: boolean,
}

const Periods = ({
  subId,
  isOpen,
  periods,
  handleToggle,
  externalToggle,
  handleCheck,
  handleSubmit,
  beginConfirmation,
  stopConfirmation,
  submitting,
  months,
  comment,
  confirmationState,
  locked,
  header,
  studentId,
  tariffId,
  tariffBundleId,
  isSms,
}: Props) => {
  const { t } = useTranslation('tariff');

  return (
    <div>
      {header && <div>{header}</div>}
      <div className={styles.periodsContent}>

        {isOpen
          && !locked

          ? periods.map(({ months_number: num, title/* , cost */ }) =>
            <RadioButton
              key={title}
              name={String(num)}
              onChange={handleCheck}
              checked={months === num}
              className={styles.radio}
              label={
                <span className={styles.label}>
                  <span>{title}</span>
                  {/* <span className={styles.cost}>{cost}</span> */}
                  <PriceDiscounted
                    className={styles.cost}
                    studentId={studentId}
                    tariffId={tariffId}
                    tariffBundleId={tariffBundleId}
                    priceType={isSms ? priceTypes.price_sms_on_months : priceTypes.price_base_on_months}
                    monthsNumber={num}
                  />
                </span>
              }
            />)

          : periods.map(({ title, months_number: num/* , cost */ }) =>
            <div key={title} className={styles.row}>
              <span className={styles.rowTitle}>{title}</span>
              {/* <span className={styles.rowCost}>{cost}</span> */}
              <PriceDiscounted
                className={styles.cost}
                studentId={studentId}
                tariffId={tariffId}
                tariffBundleId={tariffBundleId}
                priceType={isSms ? priceTypes.price_sms_on_months : priceTypes.price_base_on_months}
                monthsNumber={num}
              />
            </div>)}

        {(subId || externalToggle)
          && <div className={styles.buttons}>
            {isOpen
              && subId
              && <Confirmation
                onSubmit={handleSubmit}
                comment={comment}
                beginConfirmation={beginConfirmation}
                stopConfirmation={stopConfirmation}
                injectPrice={months
                  ? <PriceDiscounted
                    studentId={studentId}
                    tariffId={tariffId}
                    tariffBundleId={tariffBundleId}
                    priceType={priceTypes.price_base_on_months}
                    monthsNumber={months}
                  />
                  : null}
              >
                {handle =>
                  <LinkButton
                    primary
                    onClick={handle}
                    name="submit"
                    disabled={!months || submitting}
                  >
                    {submitting
                      ? t('subscribe_link_loading')
                      : t('subscribe_link')}
                  </LinkButton>
                }
              </Confirmation>}

            {!confirmationState
              && (subId || externalToggle)
              && !locked
              && <LinkButton
                primary={!isOpen}
                onClick={externalToggle || handleToggle}
                name="showPacks"
              >
                {isOpen ? t('back_link') : t('buy_subscribe')}
              </LinkButton>}
          </div>}
      </div>
    </div>
  );
};

export default enhance(Periods);
